import React, {Component} from "react";
import config from 'react-global-configuration';

import ColumnChart from 'components/amcharts/ColumnChart';
import LineChart from 'components/amcharts/LineChart';
import PieChart from 'components/amcharts/PieChart';
import StackedColumnChart from 'components/amcharts/StackedColumnChart';
import AreaChart from 'components/amcharts/AreaChart';
import BubbleChart from 'components/amcharts/BubbleChart';
import BarChart from 'components/amcharts/BarChart';

class viewDashboard extends Component {
    state = {
        data: [],
        chartHeight:"250px"
    };
    componentWillMount(){
       
       let SalesData = [{
        "country": "USA",
        "visits": 2025
      }, {
        "country": "China",
        "visits": 1882
      }, {
        "country": "Japan",
        "visits": 1809
      }, {
        "country": "Germany",
        "visits": 1322
      }, {
        "country": "UK",
        "visits": 1122
      }, {
        "country": "France",
        "visits": 1114
      }, {
        "country": "India",
        "visits": 984
      }, {
        "country": "Spain",
        "visits": 711
      }, {
        "country": "Netherlands",
        "visits": 665
      }, {
        "country": "Russia",
        "visits": 580
      }, {
        "country": "South Korea",
        "visits": 443
      }, {
        "country": "Canada",
        "visits": 441
      }, {
        "country": "Brazil",
        "visits": 395
      }];
        this.setState( {
            data: SalesData,
            chartHeight:"250px"
        } );
 }
      render() {
        return (
            <div className = "content">
                <div className = "row">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="header">
                                <h4 className="title">Column Chart</h4>
                                <p className="category">24 Hours performance</p>
                            </div>
                            <div className="ChartContent">
                                <ColumnChart data = {this.state.data} chartHeight = {this.state.chartHeight}/>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card">
                            <div className="header">
                                <h4 className="title">Line Chart</h4>
                                <p className="category">24 Hours performance</p>
                            </div>
                            <div className="ChartContent">
                                <LineChart data = {this.state.data} chartHeight = {this.state.chartHeight}/>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card">
                            <div className="header">
                                <h4 className="title">Pie Chart</h4>
                                <p className="category">24 Hours performance</p>
                            </div>
                            <div className="ChartContent">
                                <PieChart data = {this.state.data}/>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card">
                            <div className="header">
                                <h4 className="title">Stacked Column Chart</h4>
                                <p className="category">24 Hours performance</p>
                            </div>
                            <div className="ChartContent">
                                <StackedColumnChart data = {this.state.data}/>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card">
                            <div className="header">
                                <h4 className="title">Area Chart</h4>
                                <p className="category">24 Hours performance</p>
                            </div>
                            <div className="ChartContent">
                                <AreaChart data = {this.state.data}/>
                            </div>
                        </div>
                    </div>
                    

                    <div className="col-md-6">
                        <div className="card">
                            <div className="header">
                                <h4 className="title">Bubble Chart</h4>
                                <p className="category">24 Hours performance</p>
                            </div>
                            <div className="ChartContent">
                                <BubbleChart data = {this.state.data}/>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card">
                            <div className="header">
                                <h4 className="title">Bar Chart</h4>
                                <p className="category">24 Hours performance</p>
                            </div>
                            <div className="ChartContent">
                                <BarChart data = {this.state.data} chartHeight = {this.state.chartHeight}/>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
                        
          );  

      }


}
export default viewDashboard;